import en, { humanized as humanizedEn, remaining as remainingEn } from "./en";
import es, { humanized as humanizedEs, remaining as remainingEs } from "./es";
import pt, { humanized as humanizedPt, remaining as remainingPt } from "./pt";
export var humanized = {
  es: humanizedEs,
  pt: humanizedPt,
  en: humanizedEn
};
export var remaining = {
  es: remainingEs,
  pt: remainingPt,
  en: remainingEn
};
export default {
  es: es,
  pt: pt,
  en: en
};